import { ErrorBlock } from '@/components/ErrorBlock'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgForfeitJobUrl from '@/assets/misc/img_forfeit-job.svg'
import JobNoLongerAvailableIllustration from '@/components/SpotIllustration/JobNoLongerAvailableIllustration'

export interface DeleteDraftJobDialogProps {
  showing: boolean
  corporateMode: boolean
  isDeletePending: boolean
  isDeleteRejected: boolean
  deleteError?: unknown
  onClose: () => unknown
  onDelete: () => unknown
  onDismissError: () => unknown
}

export function DeleteDraftJobDialog({
  showing,
  corporateMode,
  isDeletePending,
  isDeleteRejected,
  deleteError,
  onClose,
  onDelete,
  onDismissError,
}: DeleteDraftJobDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isDeletePending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgForfeitJobUrl}
              illustration={byDesign(
                undefined,
                JobNoLongerAvailableIllustration,
              )}
              alt="Illustration of man tossing a crumbled piece of paper"
            />
          )}
          <ModalSheetContentTitle>
            Are you sure you want to delete?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            This action cannot be undone. Are you sure you want to delete this
            draft?
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      {isDeleteRejected && (
        <ErrorBlock
          tackOn="bottom"
          error={deleteError}
          onClose={() => onDismissError()}
        />
      )}
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            isDisabled={isDeletePending}
            onPress={onClose}
          />
          <Button
            label="Delete"
            onPress={onDelete}
            isDisabled={isDeletePending}
            isPending={isDeletePending}
            variant="destructive"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
